<template>
    <div>
    <!-- DIALOGS -->
        <SelectionRequiredDialog />
        <ExportSheetsDialog />
        <DeletionDialog context="SelectedSheets" />	
        <ManageTagsDialog 
			context="Sheets" 
			dir='publishing/sheets'
			idAttributeName='alvIds'
		/>
        <GemaAvRegistrationDialog />
        <MoveIntoCompanyDialog 
            :context="'Sheets'"
            :message="$t('lang_PUBLISHING_SHEETS_CAPTION_MOVE_TEXT')"
        />
    <!-- LIST PAGE COMPONENT -->
        <BaseListPage
            headline="lang_PUBLISHING_SHEETS"
            :context="context"
            :alvqa="alvqa"
            :stickyHeader="true"
        >

            <template v-slot:filter>
                <v-col cols="3">
                    <DropdownFilter 
                        :context="context + 'TypeFilter'"
                        label="lang_PUBLISHING_SHEETS_CAPTION_TYPE"
                        :items="sheetsTypeOptions"
                        :alvqa="alvqa + '-list-dropdown-sheet-types-filter'"
                    />
                </v-col>
                <v-col cols="2">
                    <DropdownFilter 
                        :context="context + 'YearsFilter'"
                        label="lang_GENERIC_PERIOD_FILTER_OPTION_YEAR"
                        itemText="text"
                        :items="sheetsYearsOptions"
                        :alvqa="alvqa + '-list-dropdown-sheet-years-filter'"
                    />
                </v-col>
			</template>
        <!-- DATA TABLE COMPONENT--> 
            <template v-slot:dataTable>
                <BaseDataTableList
                    :headers="headers"
                    :context="context"
                    :alvqa="alvqa"
                    :stickyTopSlot="true"
                >
                <!-- TOPSLOT: actions, imports etc. -->
                    <template v-slot:topSlot><SheetsTopSlot /></template>
                <!-- DATA TABLE CONTENT: columns -->
                    <template v-slot:body="{ item }">
                        <ExpandIcon 
                            :isExpanded="item.isExpanded" 
                            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-icon-expand'"
                        /> 
                        <!-- <td class="no_ellipsis"> IMAGE </td> -->
                        <td class="ellipsis">
                            <BaseTooltip 
                                :simpleText="item.item.title" 
                                :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-sheet-title'"
                            />
                        </td>
                        <td 
                            class="no_ellipsis text-left"
                            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-sheet-type'"
                        >{{ getSheetType(item.item.type) }}</td>
                        <td class="ellipsis">
                            <BaseTooltip 
                                :simpleText="item.item.composers.join(' / ')" 
                                :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-composers'"
                            />
                        </td>
                        <td class="ellipsis">
                            <BaseTooltip 
                                :simpleText="item.item.publishers.join(' / ')"
                                :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-publishers'"
                            />
                        </td>
                        <td 
                            class="no_ellipsis text-right"
                            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-when'"
                        >{{  getDate(item.item) }}</td>
                        <td 
                            class="no_ellipsis text-left"
                            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-info'"
                        >{{  item.item.type ==="film/tv" ? getFilmSheetInfo(item.item.sheetNumber) : getMusicSheetInfo(item.item) }}</td>
                    </template>
                <!-- EXPAND: Read Only View -->
                    <template v-slot:expandSlot="{ id }"><SheetReadOnly :itemId='id' /></template>
                </BaseDataTableList>
            </template>
        </BaseListPage>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import BaseDataTableList from '@/components/_base/BaseDataTableList'
import BaseListPage from '@/components/_base/BaseListPage'
import BaseTooltip from '@/components/_base/BaseTooltip'

import SheetsTopSlot from './SheetsTopSlot'
import SheetReadOnly from './_readonly/SheetReadOnly'
import ExpandIcon from '@/components/_buttons/ExpandIcon'
import DropdownFilter from '@/components/_filters/DropdownFilter'

import SelectionRequiredDialog from '@/components/_dialogs/SelectionRequiredDialog'
import DeletionDialog from '@/components/_dialogs/DeletionDialog'
import ManageTagsDialog from '@/components/_dialogs/ManageTagsDialog'
import ExportSheetsDialog from './_dialogs/ExportSheetsDialog'
import GemaAvRegistrationDialog from './_dialogs/GemaAvRegistrationDialog.vue'
import MoveIntoCompanyDialog from '@/components/_dialogs//MoveIntoCompanyDialog'

import 
    { 
        DropdownPublishingSheetsTypeOptions,
    } 
from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "SheetsList",
    components: {
        BaseDataTableList,
        BaseListPage,
        BaseTooltip,

        SheetsTopSlot,
        SheetReadOnly,
        ExpandIcon,
        DropdownFilter,

        SelectionRequiredDialog,
        DeletionDialog,
        ManageTagsDialog,
        ExportSheetsDialog,
        GemaAvRegistrationDialog,
        MoveIntoCompanyDialog,
    },
    data() {
        return {
            context: "Sheets",
            alvqa: 'publishing-sheets'
        }
    },
    computed: {
        ...mapGetters(['getSheetsSearch']),
        
        sheetsTypeOptions() {
            return DropdownPublishingSheetsTypeOptions
        },
        sheetsYearsOptions(){
            let years = []  
            let maxYear = new Date().getFullYear()+1

            for(let i = maxYear; i >= 2008; i--) {
                years.push(
                    {
                        text: i.toString(),
                        value: i, 
                        alvqa: this.alvqa + '-dropdown-period-selector-years-' + i
                    }
                )
            } 
            return years
            
        },

        headers() {
			return [
				{
					text: '', 
					value: 'data-table-select', 
                    width: "60px",
                    sortable: false,
                    class: 'text-no-wrap'
				},
				{
					text: '', 
					value: 'data-table-expand',
					align: 'center', 
                    width: "48px",
                    sortable: false,
                    class: 'text-no-wrap'
				},
                {
                    text: this.$t('lang_PUBLISHING_SHEETS_CAPTION_TITLE'), 
                    value: 'title', 
                    align: 'left', 
                    sortable: false,
                    class: 'text-no-wrap'
                }, 			
                {
                    text: this.$t('lang_PUBLISHING_SHEETS_CAPTION_TYPE'), 
                    value: 'type', 
                    align: 'left', 
                    sortable: false,
                    width: "150px",
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_PUBLISHING_CAPTION_COMPOSERS'), 
                    value: 'composers', 
                    align: 'left', 
                    sortable: false,
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_PUBLISHING_CAPTION_PUBLISHERS'), 
                    value: 'publishers', 
                    align: 'left', 
                    sortable: false,
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_WHEN'), 
                    value: 'when',
                    align: 'right', 
                    sortable: false,
                    width: "100px",
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_CAPTION_INFO'), 
                    value: 'info',
                    align: 'left', 
                    sortable: false,
                    width: "300px",
                    class: 'text-no-wrap'
                },
				{
					text: '', 
					value: 'ghost',
					sortable: false,
                    width: "1%",
                    class: 'text-no-wrap'
				},
				{
					text: '', 
					value: 'editForm',
					align: 'right',
					sortable: false,
                    width: "70px",
                    class: 'text-no-wrap'
				}
			] 
		}        
    },
    methods:{
        getSheetType(type){
            if(type ==="film/tv"){
                return this.$t("lang_PUBLISHING_SHEETS_DROPDOWN_TYPE_FILMTV")
            }else if((type ==="setlist")){
                return this.$t("lang_PUBLISHING_SHEETS_DROPDOWN_TYPE_SETLIST")
            }else{
                return this.$t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM')
            }
            
        },
        getFilmSheetInfo(sheetNumber){
            if(sheetNumber === null || sheetNumber === undefined || sheetNumber === '' ){
                sheetNumber = this.$t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM')
            }

            return this.$t('lang_PUBLISHING_SHEETS_CAPTION_SHEET_NUMBER_ABBREVIATION') + ' ' + sheetNumber 
        },
        getFormattedDate(date) {  
            if(date === null || date === undefined || date === '') return ''
            else return this.$d(new Date(date), 'alvDateFormat') 
        },
        getDate(sheet){
            if(sheet.type === "film/tv"){
                return sheet.productionYear
            }else if(sheet.type === "setlist"){
                    return this.getFormattedDate(sheet.setDate)
            }else{
                return this.$t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM')
            }
        },
        getMusicSheetInfo(sheet){

            let interpret = sheet.eventPerformer 
            let eventVenue = sheet.eventVenue 

            if(interpret === '' || interpret === null || interpret.name === null || interpret.name === ''){
                interpret = this.$t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM')
            }else{
                interpret = interpret.name
            }
            if(eventVenue === '' || eventVenue === null || eventVenue.city === null ||eventVenue.city === ''){
                 eventVenue = this.$t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM')
            }else{
                eventVenue = eventVenue.city
            }
            return interpret + ' | ' + eventVenue
        }
    }
}
</script>